<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-100 rounded-t-xl overflow-hidden"
          style="min-height: 5vh"
        >
          <div
            style="color: #28293d"
            class="bg-red-100 flex justify-start ml-1 p-1 items-center"
          >
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            <span> Surat Pengesahan PJO </span>
          </div>
          <div
            class="bg-white rounded-10 w-100 border border-1 shadow-sm rounded-t-xl p-2"
            style="min-height: 60vh"
          >
            <div class="container p-4">
              <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                SURAT PENGESAHAN PJO
              </h1>
              <div v-if="downloadUrlPjo != null">
                <a
                  class="btn btn_download"
                  @click="downloadFileEsign(documentIdPjo)"
                >
                  <font-awesome-icon icon="fa-solid fa-file" />&nbsp;Download
                  File Surat Pengesahan PJO
                </a>
              </div>
              <div class="d-flex justify-content-between">
                <div
                  class="d-flex"
                  style="padding-left: 2rem; padding-top: 0.5rem"
                >
                  <img
                    src="../../assets/images/borneo-indobara-icon.png"
                    alt="borneo-indobara-icon"
                    style="width: 5rem; height: fit-content"
                  />
                  <div style="padding-top: 2%">
                    <h5 class="fw-bold">PT BORNEO INDOBARA</h5>
                    <p class="fs-7" style="font-weight: 700; color: #555770">
                      Site Angsana - Kabupaten Tanah Bumbu<br />Provinsi
                      Kalimantan Selatan
                    </p>
                  </div>
                </div>
                <div style="padding-right: 2rem; padding-top: 0.5rem">
                  <template v-if="!isSubmitted">
                    <datepicker
                      v-model="formValues.tanggalKtt"
                      :disabled-dates="disabledDates"
                      @click="changeCalendarStyle"
                      placeholder="Pilih Tanggal"
                      class="form-control fs-6 m-w-18"
                      format="dd MMMM yyyy"
                    >
                    </datepicker>
                  </template>
                  <template v-else>
                    <p class="fs-6">
                      {{
                        moment(formValues.tanggalKtt)
                          .locale("id")
                          .format("DD MMMM YYYY")
                      }}
                    </p>
                  </template>
                </div>
              </div>
              <p class="pt-4 fs-6" style="color: #28293d">
                Nomor
                <template v-if="!isSubmitted">
                  : {{ formValues.nomorSurat }}-Generate by System
                </template>
                <template v-else> : {{ formValues.nomorSurat }} </template>
              </p>
              <div style="color: #555770; font-weight: 400" class="fs-6">
                <p class="pt-2">
                  Perihal : Surat Pengesahan PJO {{ namaBadanUsahaKontraktor }}<br />
                  Lampiran : 2 (dua) berkas<br />
                  Kepada Yth.<br />
                  <span class="fw-bold"
                    >Direktur<br />{{ namaBadanUsahaKontraktor }}<br />Di
                    tempat</span
                  >
                </p>
                <p class="pt-2">
                  Dengan hormat,<br />
                  Sehubungan dengan surat saudara Nomor
                  {{ noRegistrasi }} tanggal {{ tanggalPermohonan }} perihal
                  permohonan pengesahan PJO, pada tanggal
                  {{ tanggalSchedule }} telah dilaksanakan persentasi calon PJO
                  {{ kontraktor }} oleh KTT dengan Tim Evaluator BIB, serta
                  sesuai dengan ketentuan Peraturan Menteri Energi dan Sumber
                  Daya Mineral (ESDM) nomor 26 tahun 2018 tentang Pelaksanaan
                  Kaidah Teknik Pertambangan yang Baik dan Pengawasan
                  Pertambangan Mineral Batubara; Keputusan Menteri ESDM nomor
                  1827.K/30/MEM/2018 tentang Pedoman Pelaksanaan Kaidah Teknik
                  Pertambangan yang Baik; dan Keputusan Direktur Jenderal
                  Mineral dan Batubara nomor 185.K/37/04/DJB/2019 tentang
                  Petunjuk Teknik Pelaksanan Keselamatan Pertambangan dan
                  Pelaksanaan, Penilaian, dan Pelaporan Sistem Manajemen
                  Keselamatan Pertambangan Mineral dan Batubara.<br /><br />

                  Dengan ini kami mengesahkan penunjukkan Sdr.
                  {{ namaPjo }} sebagai PJO (Penanggung Jawab Operasional)
                  {{ namaBadanUsahaKontraktor }} di wilayah Operasional PT
                  Borneo Indobara dengan lokasi kerja di Kabupaten Tanah Bumbu,
                  Provinsi Kalimantan Selatan terhitung sejak tanggal surat ini
                  diterbitkan.<br /><br />

                  PJO bertanggung jawab kepada Kepala Teknik Tambang atas
                  terlaksananya Kaidah Teknik Pertambangan Yang Baik dalam
                  kegiatan perusahaan, meliputi namun tidak terbatas pada: aspek
                  pengawasan, aspek teknis, aspek keselamatan pertambangan,
                  aspek penerapan SMKP, aspek lingkungan hidup pertambangan,
                  aspek konservasi, aspek standardisasi dan usaha jasa
                  pertambangan.<br /><br />

                  Apabila PJO meninggalkan site, wajib menyampaikan permohonan
                  ijin kepada KTT dan menunjuk staff yang berwenang menjalankan
                  tugas PJO selama off site. Apabila PJO berhenti bekerja,
                  mengundurkan diri, atau mutasi ke tempat kerja lain, sehingga
                  menyebabkan yang bersangkutan tidak dapat melakukan tugas dan
                  fungsinya sebagai PJO di site PT Borneo Indobara, maka
                  pengesahan ini menjadi batal.<br /><br />

                  Demikian kami sampaikan, atas perkenan dan perhatiannya
                  diucapkan terima kasih.
                </p>
                <p class="pt-4">Hormat Kami<br />PT. Borneo Indobara</p>
                <p style="margin-top: 7rem; margin-bottom: 2rem">
                  <span class="fw-bold">{{
                    dataSio?.updatedAt
                      ? getKepalaTeknikTambangName(new Date(dataSio?.updatedAt))
                      : "-"
                  }}</span
                  ><br />
                  {{
                    dataSio?.updatedAt
                      ? getKepalaTeknikTambangTitle(new Date(dataSio?.updatedAt))
                      : "Kepala Teknik Tambang"
                  }}
                </p>
                <table style="width: 60%">
                  <tbody>
                  <tr>
                    <td colspan="2">Tembusan:</td>
                  </tr>
                  <tr>
                    <td>
                      <ol>
                        <li>Direktur Operasional PT BIB</li>
                        <li>Division Head HSE</li>
                        <li>
                          <template v-if="!isSubmitted">
                            <input
                              type="text"
                              class="form-control inline-input"
                              placeholder="Masukkan Divisi"
                              v-model="formValues.divisiTembusan"
                              style="width: 90%"
                            />
                          </template>
                          <template v-else>
                            {{ formValues.divisiTembusan }}
                          </template>
                        </li>
                      </ol>
                    </td>
                    <td>
                      <ul class="dash-list">
                        <li>Bpk. R.Utoro</li>
                        <li>
                          {{
                            dataSio?.updatedAt
                              ? getDivisionHeadHSEName(
                                  new Date(dataSio?.updatedAt),
                                )
                              : getDivisionHeadHSEName()
                          }}
                        </li>
                        <li>
                          <template v-if="!isSubmitted"
                            ><input
                              type="text"
                              class="form-control inline-input"
                              placeholder="Masukkan Nama"
                              v-model="formValues.namaTembusan"
                              style="width: 90%"
                          /></template>
                          <template v-else>
                            {{ formValues.namaTembusan }}
                          </template>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <p
                  class="text-center"
                  style="margin-top: 5.5rem; margin-bottom: 2rem"
                >
                  JI. Propinsi KM 180 RT 02 / RW 01, Desa Angsana, Kec. Angsana,
                  Kab. Tanah Bumbu Kalimantan Selatan 72275
                </p>
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" class="mt-20">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <!-- <button @click="$router.back()" class="btn">
                                    <font-awesome-icon icon="fa-solid fa-arrow-left" style="color: #28293d" />
                                </button> -->
            Sertifikat Compliance
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="container p-4">
              <div class="container my-4">
                <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                  SURAT PENGESAHAN PENUNJUKAN PJO
                </h1>
                <p
                  class="fs-6 text-center pt-4"
                  style="color: #28293d; font-weight: 400"
                >
                  Digunakan untuk pengesahan PJO perusahaan jasa/ mitra kerja di
                  PT Borneo Indobara, disertai surat persetujuan dari KTT
                </p>
                <p class="fs-6 pt-3" style="color: #28293d; font-weight: 400">
                  Dalam upaya pemenuhan persyaratan peraturan dan perundangan
                  yang terkait Sistem Manajemen Keselamatan Pertambangan pada
                  Elemen Organisasi dan Personil yaitu:
                </p>
                <ol
                  type="1"
                  class="list-decimal font-normal ml-7 my-4 fs-6 text-[#28293d]"
                >
                  <li>
                    PerMen ESDM No. 26/2018 tentang Pelaksanaan Kaidah
                    Pertambangan yang Baik dan Pengawasan Pertambangan Mineral
                    dan Batubara
                  </li>
                  <li>
                    KepMen ESDM No. 1827 K/30/MEM/2018 tentang Pedoman
                    Pelaksanaan Kaidah Pertambangan yang Baik
                  </li>
                  <li>
                    KepDirjen ESDM Minerba No 185.K/37 tahun 2019 Petunjuk
                    Teknis Pelaksanaan Keselamatan Pertambangan dan Pelaksanaan,
                    Penilaian, dan Pelaporan Sistem Manajemen Keselamatan
                    Pertambangan Minerba Dan Batubara
                  </li>
                  <li>ISO 14001:2015 tentang Sistem Manajemen Lingkungan</li>
                  <li>ISO 45001:2018 tentang Sistem Manajemen K3</li>
                  <li>BIB – HSE – MAN – 001 Manual SMKPLH</li>
                  <li>
                    BIB – HSE – ES – 2.09 Pengelolaan Perusahaan Jasa
                    Pertambangan
                  </li>
                  <li>BIB – HSE – PPO – 096 Penunjukan & Evaluasi PJO</li>
                  <li>
                    BIB - HSE - SKR - 011 Penilaian Penanggung Jawab Operasional
                    (PJO) dan Ketentuan Penggantian PJO
                  </li>
                  <li>
                    BIB – HSE – SKR – 012 Penilaian Kualifikasi Perusahaan Jasa
                    Pertambangan
                  </li>
                </ol>
                <div class="fs-6" style="color: #28293d; font-weight: 400">
                  <p>
                    Dan berdasarkan surat KTT dengan nomor
                    {{
                      formValues.nomorSurat
                        ? formValues.nomorSurat
                        : "___________________"
                    }}
                    tertanggal
                    {{
                      formValues.tanggalKtt
                        ? moment(formValues.tanggalKtt)
                            .locale("id")
                            .format("DD MMMM yyyy")
                        : "_________"
                    }}, serta dengan mempertimbangkan posisi dalam organisasi,
                    kualifikasi, dan kompetensi yang dimiliki, maka dengan ini
                    telah kami tunjuk:
                  </p>
                </div>

                <!-- form di sini -->
                <form action="#" @submit.prevent="preventSubmit">
                  <div class="row mb-2 px-5 ml-3">
                    <table class="fs-6">
                      <tbody>
                      <tr>
                        <td width="28%">Nama</td>
                        <td>: {{ namaPjo }}</td>
                      </tr>
                      <tr>
                        <td width="28%">Perusahaan</td>
                        <td>: {{ namaBadanUsahaKontraktor }}</td>
                      </tr>
                      <tr>
                        <td width="28%">Jabatan</td>
                        <td>: {{ jabatanPjo }}</td>
                      </tr>
                      <tr>
                        <td width="28%">Kompetensi</td>
                        <td class="d-flex align-items-center">
                          :
                          <select
                            class="form-select form-select-sm"
                            name="kompetensi"
                            v-if="!isSubmitted"
                            id="kompetensi"
                            v-model="formValues.kompetensi"
                          >
                            <option
                              :value="row.value"
                              v-for="(row, index) in kompetensiPjoOpt"
                              :key="index"
                            >
                              {{ row.label }}
                            </option>
                          </select>
                          <template v-else>
                            {{ formValues.kompetensi }}
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td width="28%">No. Sertifikat/Registrasi</td>
                        <td class="d-flex align-items-center">
                          : {{ formValues.noSertifikat }} &nbsp;<span
                            type="button"
                            class="btn btn-sm btn-danger"
                            data-bs-toggle="modal"
                            data-bs-target="#editSertifikat"
                            v-if="!isSubmitted"
                            ><font-awesome-icon
                              icon="fa-solid fa-edit"
                              style=""
                          /></span>
                        </td>
                      </tr>
                      <tr>
                        <td width="28%">Sebagai</td>
                        <td>: Penanggung Jawab Operasional (PJO)</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <p
                    class="fs-6"
                    style="padding-top: 1rem; color: #28293d; font-weight: 400"
                  >
                    Demikian penunjukan ini untuk dijalankan dengan komitmen dan
                    kesungguhan untuk mencegah terjadinya kecelakaan dan
                    pencemaran lingkungan di area kerja sesuai peraturan
                    perundangan yang berlaku, dan Kebijakan Keselamatan
                    Pertambangan dan Lingkungan Hidup PT Borneo Indobara, serta
                    komitmen terhadap implementasi dari Sistem Manajemen
                    Keselamatan Pertambangan (SMKP).
                  </p>
                  <div class="row">
                    <div class="col-md-4 text-center">
                      <p
                        class="fs-6 pt-3"
                        style="color: #28293d; font-weight: 400"
                      >
                        Disahkan di Angsana:
                        <datepicker
                          v-if="!isSubmitted"
                          v-model="formValues.tanggalPengesahan"
                          :disabled-dates="disabledDates"
                          placeholder="Pilih Tanggal Disahkan"
                          class="form-control fs-6 inline-input m-w-18 text-start"
                          format="dd MMMM yyyy"
                        >
                        </datepicker>
                        <template v-else>
                          {{
                            moment(formValues.tanggalPengesahan)
                              .locale("id")
                              .format("DD MMMM YYYY")
                          }} </template
                        ><br />Disahkan Oleh:
                      </p>

                      <p style="margin-top: 7rem">
                        <span class="fw-bold text-decoration-underline">{{
                          dataSio?.updatedAt
                            ? getKepalaTeknikTambangName(
                                new Date(dataSio?.updatedAt),
                              )
                            : "-"
                        }}</span
                        ><br />{{
                          dataSio?.updatedAt
                            ? getKepalaTeknikTambangTitle(
                                new Date(dataSio?.updatedAt),
                              )
                            : "Kepala Teknik Tambang"
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="row" v-if="!isSubmitted">
                    <div
                      class="col-md-12 d-flex justify-content-end"
                      v-if="userData.role.includes('ADMIN')"
                    >
                      <button
                        type="button"
                        @click="clickSimpan()"
                        class="btn btn_cari w-25"
                      >
                        Simpan
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <div
    class="modal fade rounded-top-5"
    id="editSertifikat"
    tabindex="-1"
    aria-labelledby="editPjp"
    aria-hidden="true"
  >
    <div class="modal-dialog-centered rounded-top-5">
      <div
        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
        style="min-height: 156px; min-width: 350px"
      >
        <div
          class="modal-content rounded-bottom-5 rounded-top-4 border-0"
          style="
            min-height: 100px;
            min-width: 350px;
            background: rgba(181, 26, 26, 1);
          "
        >
          <div class="d-flex justify-content-end w-100 p-2">
            <button
              type="button"
              id="btnClose"
              class="btn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src="../../assets/icons/close_whaite.png"
                alt="icon"
                width="24"
                height="24"
              />
            </button>
          </div>
          <div
            class="p-3 text-white text-center mb-3"
            style="font-family: Inter, sans-serif"
          >
            <h4 class="fw-bold">Edit No Sertifikat</h4>
          </div>
        </div>
        <div class="modal-body">
          <div class="p-1">
            <form>
              <div class="d-flex justify-content-center">
                <div class="form-group mt-1 mb-2" style="width: 75%">
                  <div class="row mb-4">
                    <div class="col-4">
                      <label for="noSertifikat" class="form-label fs-8 fw-bold"
                        >No. Sertifikat</label
                      >
                    </div>
                    <div class="col-8">
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="noSertifikat"
                        placeholder="Masukkan No. Sertifikat"
                        v-model="noSertifikat"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  @click="formValues.noSertifikat = noSertifikat"
                  type="button"
                  class="btn btn-sm bg-danger w-75 text-white"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<style scoped>
.btn_cari {
  background: #555770 !important;
}
.btn_download {
  background: #dd3737 !important;
  color: #ffffff !important;
}

.inline-input {
  display: inline-block;
  width: auto;
  /* max-width: 200px; */
}

.m-w-18 {
  max-width: 180px;
}

.m-w-20 {
  max-width: 200px;
}

ul.dash-list {
  list-style-type: none;
  padding-left: 0;
}

ul.dash-list li::before {
  content: "- ";
  padding-right: 10px;
}
</style>
<script>
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../GlobalDataMixin";
import axios from "axios";
import Swal from "sweetalert2";
import Datepicker from "vuejs3-datepicker";

import {
  API_BASE_URL,
  CMS_DOWNLOAD_ESIGN,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_GET_KELENGKAPAN_SIO,
  CMS_GET_SIOID,
  CMS_SIO_GET_DASHBOARD,
  CMS_SIO_GET_PJOPENGESAHAN,
  CMS_SIO_UPLOAD_PERSETUJUAN,
} from "../../constants.js";
import { capitalized } from "@/utilities/helpers";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  getKepalaTeknikTambangName,
  getKepalaTeknikTambangTitle,
} from "@/config/tempKepalaTeknikTambang";
import { getDivisionHeadHSEName } from "@/config/tempDivisionHeadHSE";

const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;
const url_get_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_get_siodashboard = API_BASE_URL + CMS_SIO_GET_DASHBOARD;
const url_get_pjopengesahan = API_BASE_URL + CMS_SIO_GET_PJOPENGESAHAN;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_sio_upload_persetujuan = API_BASE_URL + CMS_SIO_UPLOAD_PERSETUJUAN;
const url_download_esign = API_BASE_URL + CMS_DOWNLOAD_ESIGN;

export default {
  mixins: [GlobalDataMixin],
  name: "FormSuratPengesahanPenunjukanPJO",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
    Datepicker,
  },

  data() {
    return {
      role: "",
      isLoading: false,
      refIDForm: 1,
      noRegistrasi: "",
      tanggalPermohonan: "",
      tanggalSchedule: "",
      namaPjo: "",
      jabatanPjo: "",
      noSertifikat: "",
      kontraktor: "",
      badanUsaha: "",
      sioID: null,
      kontraktorId: null,
      isSubmitted: false,
      downloadUrlPjo: null,
      documentIdPjo: null,
      formValues: {
        tanggalPengesahan: "",
        nomorSurat: "",
        tanggalKtt: "",
        divisiTembusan: "",
        namaTembusan: "",
        kompetensi: "",
      },
      validasiFile: {
        type: false,
        size: false,
      },
      kompetensiPjoOpt: [
        { value: "POP", label: "POP (Pengawas Operasional Pertama)" },
        { value: "POM", label: "POM (Pengawas Operasional Madya)" },
        { value: "POU", label: "POU (Pengawas Operasional Utama)" },
      ],
      disabledDates: {
        to: new Date(Date.now() - 86400000),
      },
      dataSio: null,
    };
  },
  computed: {
    namaBadanUsahaKontraktor() {
      const bu = (this.badanUsaha || "").trim();
      const kont = (this.kontraktor || "").trim();

      if (!bu) return kont;
      if (!kont) return bu;

      const cleanBu = bu.replace(/\.+$/, "");
      const escapedBu = cleanBu.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const regex = new RegExp(`(^|\\b)${escapedBu}(\\b|\\.|$)`, "i");

      if (regex.test(kont)) {
        return kont;
      }

      return `${bu} ${kont}`;
    },
  },
  mounted() {
    this.sioID = this.$route.params.id;
    this.kontraktorId = this.$route.params.kontraktorId;
    this.getKelengkapan(this.sioID);
    this.getKontraktor(this.kontraktorId);
    this.getSioID(this.kontraktorId);
    this.getSioDashboard(this.sioID);
  },
  methods: {
    preventSubmit() {
      console.log("prevent submit");
    },
    capitalized,
    getKepalaTeknikTambangName,
    getKepalaTeknikTambangTitle,
    getDivisionHeadHSEName,
    getKelengkapan(sio_id) {
      axios
        .get(url_get_kelengkapan + sio_id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          this.namaPjo = response.data.namaPjo;
          this.jabatanPjo = response.data.jabatanPjo;
          this.noSertifikat =
            response.data.nomorSertifikatPjo != null
              ? response.data.nomorSertifikatPjo
              : "-";
          this.formValues.noSertifikat = this.noSertifikat;
          console.log("get kelangkapan =>", response);
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
    getKontraktor(kont_id) {
      axios
        .get(url_get_kontraktor + kont_id, {
          headers: { accept: "application/json" },
        })
        .then((response) => {
          console.log("getKontraktor ==> ", response);
          this.kontraktor = this.capitalized(
            response.data.detailKontraktor.namaKontraktor
          );
          this.badanUsaha = response.data.detailKontraktor.badanUsaha;
          this.formValues.kompetensi =
            response.data.detailKontraktor.kompetensiPjo;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data Detail Kontraktor : " + error.message);
          console.error("Error fetching data:", error.message);
        });
    },
    clickSimpan() {
      if (this.validasiForm()) {
        Swal.fire({
          title: "Simpan Pengesahan",
          text: "Apakah anda yakin akan menyimpan data pengesahan ini ?",
          icon: "warning",
          showCancelButton: true,
          showConfirmButton: true,
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.isLoading = true;
            this.simpanSuratPengesahanPJO();
          }
        });
      } else {
        alert("Lengkapi form!");
      }
    },
    simpanSuratPengesahanPJO() {
      let bodyJson = {
        noSertifikat: this.formValues.noSertifikat,
        tanggalPengesahan: this.formValues.tanggalPengesahan,
        nomorSurat: this.formValues.nomorSurat,
        tanggalKtt: this.formValues.tanggalKtt,
        idSio: parseInt(this.sioID),
        divisiTembusan: this.formValues.divisiTembusan,
        namaTembusan: this.formValues.namaTembusan,
        kompetensi: this.formValues.kompetensi,
        tahun: new Date().getFullYear(),
      };
      axios
        .post(url_sio_upload_persetujuan, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response saveSuratPengesahanPJO ==> ", response);

          window.location.reload();
        })
        .catch((error) => {
          console.log("error saveSuratPengesahanPJO : ", error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan saat simpan pengesahan!",
          });
          this.isLoading = false;
        });
    },
    validasiForm() {
      if (
        this.formValues.noSertifikat == "" ||
        this.formValues.tanggalPengesahan == "" ||
        this.formValues.nomorSurat == "" ||
        this.formValues.tanggalKtt == "" ||
        this.formValues.divisiTembusan == "" ||
        this.formValues.namaTembusan == "" ||
        this.formValues.kompetensi == ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    getSioDashboard(sio_id) {
      axios
        .get(url_get_siodashboard + sio_id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("getSioDashboard ==>", response);
          let ret_dash = response.data.data;
          if (ret_dash.length > 0) {
            for (let i = 0; i < ret_dash.length; i++) {
              if (ret_dash[i].idForm == this.refIDForm) {
                this.getPJOPengesahan(ret_dash[i].id);
                this.tanggalPermohonan =
                  ret_dash[i].updatedAt != null
                    ? moment(ret_dash[i].updatedAt)
                        .locale("id")
                        .format("DD MMMM YYYY")
                    : "";
              }
            }
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },
    getPJOPengesahan(idform) {
      axios
        .get(url_get_pjopengesahan + idform, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("getPJOPengesahan ", response);
          let dt = response.data.data;

          if (dt != null) {
            this.noRegistrasi = dt.noRegistrasi == null ? "" : dt.noRegistrasi;
          }

          if (dt != null && this.isSubmitted === true) {
            this.formValues.noSertifikat = dt.noSertifikat;
            this.formValues.tanggalPengesahan = dt.tanggalPengesahan;
            this.formValues.nomorSurat = dt.noSurat;
            this.formValues.tanggalKtt = dt.tanggalKtt;
            this.formValues.divisiTembusan = dt.divisiTembusan;
            this.formValues.namaTembusan = dt.namaTembusan;
            this.formValues.kompetensi = dt.kompetensi;
          } else {
            let now = new Date();
            this.formValues.nomorSurat = `BIB-KTT-PPJO-${now.getFullYear()}-${String(
              now.getMonth() + 1
            ).padStart(2, "0")}`;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },
    getSioID(kont_id) {
      axios
        .get(url_get_sioid + kont_id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("get CoC ID ==> ", response);
          if (response.data != null) {
            let dt = response.data;
            this.tanggalSchedule =
              dt.schedule != null
                ? moment(dt.schedule).locale("id").format("DD MMMM YYYY")
                : "";
            this.isSubmitted = dt.data.documentIdPjo ? true : false;
            this.documentIdPjo = dt.data.documentIdPjo;
            this.downloadUrlPjo = dt.data.downloadUrlPjo;
            this.dataSio = response.data.data;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    changeCalendarStyle() {
      document.querySelector(".vuejs3-datepicker__calendar").style.right = 0;
    },
    downloadFileEsign(id) {
      this.isLoading = true;
      let filename = `File Pengesahan PJO ${this.kontraktor}.zip`;
      axios
        .get(url_download_esign, {
          params: { id: id },
          headers: {
            role: this.userData.role,
            Authorization: `Bearer ${this.userData.token}`,
            Accept: "application/json",
          },
          responseType: "blob", // Ensure binary data handling
        })
        .then((response) => {
          if (response.status !== 200) {
            throw new Error("Network response was not ok");
          }
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); // Use the filename from the header or default one
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url); // Clean up the URL object
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error downloading file:", error);
        });
    },
  },
};
</script>
